/**
 * Curated mappings to the exercises-dataset GIFs.
 *
 * The dataset's README/NOTICE says the animation media is © Gym visual,
 * distributed at 180×180, and requires this attribution. We keep the URLs
 * external so we do not silently redistribute the media in our bundle.
 */
const base = 'https://raw.githubusercontent.com/hasaneyldrm/exercises-dataset/main/';
const attribution = '© Gym visual — https://gymvisual.com/';
const gif = (path: string) => ({ mediaType: 'gif' as const, mediaUrl: `${base}${path}`, mediaProvider: 'exercises-dataset / Gym visual', mediaAttribution: attribution });

export const exerciseMediaMap = {
  // The upstream set has no exact jumping-jack, arm-swing, or bird-dog records;
  // these are the closest same-pattern demonstrations available there.
  'jumping-jack': gif('videos/3222-6FMU51h.gif'),
  'arm-swings': gif('videos/0041-b2Uoz54.gif'),
  'bird-dog': gif('videos/3239-h1ezqSu.gif'),
  'dead-bug': gif('videos/0276-iny3m5y.gif'),
  'worlds-greatest-stretch': gif('videos/1604-DFGXwZr.gif'),
  'band-pull-apart': gif('videos/0993-sTfvVsG.gif'),
  'chest-supported-row': gif('videos/1318-yaMIo4D.gif'),
  'barbell-row': gif('videos/0027-eZyBC3j.gif'),
  'lat-pulldown': gif('videos/2330-LEprlgG.gif'),
  'seated-cable-row': gif('videos/0861-fUBheHs.gif'),
  'dumbbell-curl': gif('videos/0294-NbVPDMW.gif'),
  'hammer-curl': gif('videos/0313-slDvUAU.gif'),
  'goblet-squat': gif('videos/1760-yn8yg1r.gif'),
  'reverse-lunge': gif('videos/0381-SSsBDwB.gif'),
  'hip-thrust': gif('videos/3236-Pjbc0Kt.gif'),
  'glute-bridge': gif('videos/3013-u0cNiij.gif'),
  'romanian-deadlift': gif('videos/1459-rR0LJzx.gif'),
  'front-squat': gif('videos/0042-zG0zs85.gif'),
  'push-up': gif('videos/0662-I4hDWkc.gif'),
  'chest-press': gif('videos/0577-T0yTjgW.gif'),
  'machine-fly': gif('videos/0596-v3xmPAR.gif'),
  'tricep-pushdown': gif('videos/1723-qRZ5S1N.gif'),
  'overhead-tricep-extension': gif('videos/1722-1xHyxys.gif'),
  'lateral-raise': gif('videos/0334-DsgkuIt.gif'),
  'shoulder-press': gif('videos/0361-84RyJf8.gif'),
  'machine-reverse-fly': gif('videos/0602-myfUsKf.gif'),
  'push-press': gif('videos/1700-FS63wTN.gif'),
  'high-knees': gif('videos/3655-J9zIWig.gif'),
  'mountain-climber': gif('videos/0630-RJgzwny.gif'),
  'bicycle-crunch': gif('videos/0972-tZkGYZ9.gif'),
  'pallof-press': gif('videos/0979-9pa4H5m.gif'),
  'burpee': gif('videos/1160-dK9394r.gif'),
  'skater-hops': gif('videos/3361-zfNHMN9.gif'),
  'squat-jumps': gif('videos/3222-6FMU51h.gif'),
  'side-plank': gif('videos/3544-5VXmnV5.gif'),
  'plank': gif('videos/3665-hCjGsRQ.gif'),
  'incline-burpee': gif('videos/1160-dK9394r.gif'),
  'upright-row': gif('videos/0120-UDlhcO8.gif'),
  'barbell-curl': gif('videos/0023-Yza7XrQ.gif'),
  'russian-twist': gif('videos/0687-XVDdcoj.gif'),
  'shrug': gif('videos/0095-dG7tG5y.gif'),
  'front-raise': gif('videos/0041-b2Uoz54.gif'),
  'standing-quad': gif('videos/3533-6YUfHPL.gif'),
  'figure-four': gif('videos/2567-QY39eBr.gif'),
  'childs-pose': gif('videos/1346-f38OEuO.gif'),
  'crush-grip-press': gif('videos/0289-SpYC0Kp.gif'),
  'weighted-sit-up': gif('videos/0832-s8nrDXF.gif'),
  'bent-over-y-raise': gif('videos/0380-v1qBec9.gif'),
  'deadlift': gif('videos/0032-ila4NZS.gif'),
  'dumbbell-row': gif('videos/0293-BJ0Hz5L.gif'),
  'chainsaw-row': gif('videos/0292-C0MA9bC.gif'),
  'gorilla-row': gif('videos/0522-Ca76jUE.gif'),
  'double-arm-kb-row': gif('videos/1345-wf24o8S.gif'),
  'stiff-leg-deadlift': gif('videos/0432-5eLRITT.gif'),
  'hang-power-clean': gif('videos/0648-SiWCcTN.gif'),
  'hamstring-deadlift': gif('videos/0116-hrVQWvE.gif'),
  'single-leg-kb-deadlift': gif('videos/1757-gKozT8X.gif')
} as const;
